'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tween = exports.ticker = exports.plugins = exports.easing = exports.TweenOneGroup = undefined;

var _TweenOne = require('./TweenOne');

var _TweenOne2 = _interopRequireDefault(_TweenOne);

var _Tween = require('./Tween');

var _Tween2 = _interopRequireDefault(_Tween);

var _TweenOneGroup = require('./TweenOneGroup');

var _TweenOneGroup2 = _interopRequireDefault(_TweenOneGroup);

var _easing2 = require('./easing');

var _easing3 = _interopRequireDefault(_easing2);

var _plugins2 = require('./plugins');

var _plugins3 = _interopRequireDefault(_plugins2);

var _ticker2 = require('./ticker');

var _ticker3 = _interopRequireDefault(_ticker2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// export this package's api
_TweenOne2['default'].TweenOneGroup = _TweenOneGroup2['default'];
_TweenOne2['default'].easing = _easing3['default'];
_TweenOne2['default'].plugins = _plugins3['default'];
_TweenOne2['default'].ticker = _ticker3['default'];
_TweenOne2['default'].Tween = _Tween2['default'];

exports['default'] = _TweenOne2['default'];
var TweenOneGroup = exports.TweenOneGroup = _TweenOneGroup2['default'];

var easing = exports.easing = _easing3['default'];

var plugins = exports.plugins = _plugins3['default'];

var ticker = exports.ticker = _ticker3['default'];

var Tween = exports.Tween = _Tween2['default'];